import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export default {
    // TODO: this is hacky, find better solution
    br: _jsx("br", {}),
    nbsp: _jsx(_Fragment, { children: "\u00A0" }),
    // Default rich tags
    strong: (chunks) => _jsx("strong", { children: chunks }),
    span: (chunks) => _jsx("span", { children: chunks }),
};
